module.exports = __webpack_public_path__ + "img/icon03.69ea3cc2.png";